module.exports = __webpack_public_path__ + "static/img/banner-汇丰-HK@2x.b422678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/banner-汇丰-HK@2x.png
// module id = 2NHq
// module chunks = 0